import React from "react";
import { verificationActions } from "actions/verification.actions";
import { connect } from "react-redux";
import AccountConfirmationSuccess from "./AccountConfirmationSuccess";
import AccountVerificationError from "./AccountVerificationError";

class AccountConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSuccess: false,
      hasExpired: undefined,
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    let token = this.props.match.params.token;
    if (this.props.expired === undefined && this.props.success === undefined) {
      if (token) {
        dispatch(verificationActions.verify(token));
      }
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.expired !== undefined) {
      if (nextProps.expired === true) {
        this.setState({
          hasExpired: nextProps.expired,
          isSuccess: false,
        });
      }
    }

    if (nextProps.success !== undefined) {
      if (nextProps.success === true) {
        this.setState({
          isSuccess: nextProps.success,
          hasExpired: false,
        });
      }
    }
  }

  render() {
    const { isSuccess, hasExpired } = this.state;
    return (
      <div>
        {isSuccess && <AccountConfirmationSuccess />}

        {hasExpired && <AccountVerificationError />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { success, expired } = state.verification;
  return {
    success,
    expired,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verification: (token) => dispatch(verificationActions.verify(token)),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountConfirmation);
